/**
 * @Author: Junaid Atari junaid.attari@invozone.dev
 * @Date: 2025-02-17 17:00:33
 */

import {type AnySchema, object} from 'yup';

// helpers
import {genericFieldsSchema, HandleProps} from '~/helpers/form-fields';

// types
import type {PostcardField, PostcardFields} from '~/handles/postcard/fields-info';

export type PostCardProps = HandleProps<PostcardFields>

export const schema = object<PostcardFields, Record<PostcardField, AnySchema>>().shape({
  ...genericFieldsSchema,
});
